var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFreehandGlyph = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 33 30"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M24.327 30q-.483 0-.987-.072c-7.573-1.094-7.9-7.303-8.19-14.104-.238-5.549-.482-9.785-4.237-11.983-1.515-.888-3.393-1.089-5.019-.54-1.398.473-2.467 1.46-3.01 2.78a1.497 1.497 0 0 1-1.956.814 1.5 1.5 0 0 1-.816-1.957C.993 2.803 2.704 1.211 4.935.458c2.442-.822 5.238-.526 7.49.792 5.168 3.025 5.461 8.389 5.72 14.445.317 7.482.855 10.574 5.622 11.264 2.63.375 4.744-2.014 6.491-4.404a1.5 1.5 0 0 1 2.42 1.773c-1.279 1.748-4.152 5.67-8.35 5.672"
})));
export default SvgFreehandGlyph;